import { ReactNode } from 'react';
import styled from 'styled-components';

import Breakpoint from 'packages/kakapo-ui-kit/helpers/Breakpoint';
import { applyColorFromProps } from 'packages/kakapo-ui-kit/helpers/Theme';

interface IElementProps {
	spaced?: boolean;
	color?: string;
}

interface IProps {
	title: string;
	htmlFor?: string;
	spaced?: boolean;
	children?: ReactNode;
	color?: string;
}

const Element = styled.label<IElementProps>`
	font-size: 14px;
	color: ${(props) => applyColorFromProps(props, 'slateBlue')};

	margin-bottom: ${(props) => (props.spaced === true ? '10px' : '0')};
	display: block;

	@media screen and (max-width: ${Breakpoint.Small}) {
		font-size: 13px;
		margin-bottom: 6px;
	}
`;

export default function Label({ title, htmlFor, children, color, spaced = true }: IProps) {
	return (
		<Element spaced={spaced} htmlFor={htmlFor} color={color}>
			{children}
			{title}
		</Element>
	);
}
